/**
 * カードマーク種別を管理するComposable
 */
export function useCardMarkType() {
  // カードマーク種別の定数
  const CARD_MARKS = {
    MarkClear: "00",
    Mark1: "10",
    Mark2: "20",
    Mark3: "30",
    Mark4: "40",
    Mark5: "50",
    Mark6: "60",
    Mark7: "70",
    Mark8: "80",
    Mark9: "90",
    Mark10: "A1",
    Mark11: "A2",
    Mark12: "A3",
    Mark13: "A4"
  };

  const CLEAR_ICON = {
    label: "クリア",
    value: "00",
    color: "grey",
    icon: "filter_none",
    icon_alt: "clear"
  };

  const CARD_ICONS = [
    {
      label: "マーク1",
      value: "10",
      color: "red",
      icon: "filter_1"
    },
    {
      label: "マーク2",
      value: "20",
      color: "yellow darken-2",
      icon: "filter_2"
    },
    {
      label: "マーク3",
      value: "30",
      color: "green",
      icon: "filter_3"
    },
    {
      label: "マーク4",
      value: "40",
      color: "blue",
      icon: "filter_4"
    },
    {
      label: "マーク5",
      value: "50",
      color: "purple",
      icon: "filter_5"
    },
    {
      label: "マーク6",
      value: "60",
      color: "orange darken-2",
      icon: "filter_6"
    },
    {
      label: "マーク7",
      value: "70",
      color: "teal",
      icon: "filter_7"
    },
    {
      label: "マーク8",
      value: "80",
      color: "pink",
      icon: "filter_8"
    },
    {
      label: "マーク9",
      value: "90",
      color: "indigo",
      icon: "filter_9"
    },
    {
      label: "マーク10",
      value: "A1",
      color: "lime darken-2",
      icon: "thumb_up"
    },
    {
      label: "マーク11",
      value: "A2",
      color: "deep-purple",
      icon: "diamond"
    },
    {
      label: "マーク12",
      value: "A3",
      color: "cyan darken-2",
      icon: "stars"
    },
    {
      label: "マーク13",
      value: "A4",
      color: "amber darken-2",
      icon: "mood"
    }
  ];

  const getMark = mark => {
    return CARD_ICONS.find(cardIcon => cardIcon.value === mark);
  };

  // 判定関数
  const isNone = cardMarkType => {
    return cardMarkType === null || cardMarkType === CARD_MARKS.MarkClear;
  };

  const isMark1 = cardMarkType => cardMarkType === CARD_MARKS.Mark1;
  const isMark2 = cardMarkType => cardMarkType === CARD_MARKS.Mark2;
  const isMark3 = cardMarkType => cardMarkType === CARD_MARKS.Mark3;
  const isMark4 = cardMarkType => cardMarkType === CARD_MARKS.Mark4;
  const isMark5 = cardMarkType => cardMarkType === CARD_MARKS.Mark5;
  const isMark6 = cardMarkType => cardMarkType === CARD_MARKS.Mark6;
  const isMark7 = cardMarkType => cardMarkType === CARD_MARKS.Mark7;
  const isMark8 = cardMarkType => cardMarkType === CARD_MARKS.Mark8;
  const isMark9 = cardMarkType => cardMarkType === CARD_MARKS.Mark9;
  const isMark10 = cardMarkType => cardMarkType === CARD_MARKS.Mark10;
  const isMark11 = cardMarkType => cardMarkType === CARD_MARKS.Mark11;
  const isMark12 = cardMarkType => cardMarkType === CARD_MARKS.Mark12;
  const isMark13 = cardMarkType => cardMarkType === CARD_MARKS.Mark13;

  return {
    CARD_MARKS,
    CARD_ICONS,
    CLEAR_ICON,
    getMark,
    isNone,
    isMark1,
    isMark2,
    isMark3,
    isMark4,
    isMark5,
    isMark6,
    isMark7,
    isMark8,
    isMark9,
    isMark10,
    isMark11,
    isMark12,
    isMark13
  };
}
